import React, { useEffect, useState } from 'react';
import { logAPI } from '../api/client';
import { C, css } from '../theme';

function LogItem({ item, onDelete }) {
  let numbers = [];
  try { numbers = JSON.parse(item.numbers_seen); } catch {}
  const clean = item.ai_response?.replace(/\*\*/g, '') || '';

  return (
    <div style={s.logItem}>
      <div style={s.logDt}>
        <div>{item.log_date}</div>
        <div style={{ fontSize:9, marginTop:2 }}>{item.log_time || ''}</div>
      </div>
      <div style={{ flex:1 }}>
        <div style={{ display:'flex', flexWrap:'wrap', gap:5, marginBottom:4 }}>
          {numbers.map(n => <span key={n} style={css.ntag}>{n}</span>)}
        </div>
        {item.user_state && <div style={{ fontSize:11, color:C.text2, lineHeight:1.4 }}>"{item.user_state}"</div>}
        {clean && <div style={{ fontSize:12, color:C.text2, marginTop:4, lineHeight:1.5 }}>{clean.substring(0, 180)}{clean.length > 180 ? '...' : ''}</div>}
      </div>
      <button type="button" onClick={() => onDelete(item.id)} style={s.delBtn}>✕</button>
    </div>
  );
}

export default function LogScreen() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    logAPI.getAll()
      .then(r => setLogs(r.data.logs || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  async function deleteLog(id) {
    if (!window.confirm('حذف هذا السجل؟')) return;
    await logAPI.delete(id).catch(() => {});
    setLogs(p => p.filter(l => l.id !== id));
  }

  function exportLog() {
    const text = logs.map(l => {
      let nums = []; try { nums = JSON.parse(l.numbers_seen); } catch {}
      return `${l.log_date} ${l.log_time||''}\nالأرقام: ${nums.join(', ')}\n${l.user_state ? `الحالة: ${l.user_state}\n` : ''}${l.ai_response?.replace(/\*\*/g,'') || ''}\n${'—'.repeat(40)}`;
    }).join('\n\n');
    const a = document.createElement('a');
    a.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(text);
    a.download = 'jadhr-alfalak-log.txt';
    a.click();
  }

  return (
    <div style={css.card}>
      <div style={s.cardTitle}>
        <span>السجل اليومي</span>
        <div style={{ flex:1, height:1, background:`linear-gradient(to left, transparent, ${C.goldDim})` }} />
      </div>

      {loading && <div style={{ textAlign:'center', color:C.text2, padding:28, fontSize:13 }}>جاري التحميل...</div>}
      {!loading && logs.length === 0 && (
        <div style={{ textAlign:'center', color:C.text2, fontSize:13, padding:28 }}>لا يوجد سجلات بعد</div>
      )}

      {logs.map(log => <LogItem key={log.id} item={log} onDelete={deleteLog} />)}

      {logs.length > 0 && (
        <button type="button" onClick={exportLog} style={s.exportBtn}>
          📥 تصدير السجل كملف نصي
        </button>
      )}
    </div>
  );
}

const s = {
  cardTitle: { fontFamily:'Amiri, serif', fontSize:16, color:C.gold, marginBottom:16, display:'flex', alignItems:'center', gap:10 },
  logItem: { background:C.bg3, border:`1px solid ${C.border}`, borderRadius:12, padding:'12px 14px', marginBottom:8, display:'flex', gap:12, alignItems:'flex-start' },
  logDt: { fontSize:10, color:C.text2, minWidth:66, textAlign:'center', background:C.bg4, borderRadius:8, padding:5, lineHeight:1.5 },
  delBtn: { background:'none', border:'none', color:C.text2, cursor:'pointer', fontSize:13, opacity:.4, transition:'opacity .2s, color .2s', padding:'0 4px' },
  exportBtn: { width:'100%', background:C.bg4, border:`1px solid ${C.goldDim}`, borderRadius:10, padding:10, color:C.gold, fontSize:13, cursor:'pointer', marginTop:10, transition:'all .2s', fontFamily:'Cairo, sans-serif' },
};
